module.exports = ".card .card-header {\n  font-weight: bold; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard-charts/dashboard-charts.component.scss
// module id = ./src/app/components/dashboard-charts/dashboard-charts.component.scss
// module chunks = main